<template>
    <div v-if="$store.getters.ThereIsActiveModal" class="modal_mask"></div>
    <AddHouseModal v-if="$store.getters.ModalIsActive('AddHouse')"/>
    <DeleteHouseModal v-if="$store.getters.ModalIsActive('DeleteHouse')"/>
    <AddFlatModal v-if="$store.getters.ModalIsActive('AddFlat')"/>
    <AddIntercom v-if="$store.getters.ModalIsActive('AddIntercom')"/>
    <UpdateIntercomModal v-if="$store.getters.ModalIsActive('UpdateIntercom')"/>
    <ErrorModal v-if="$store.getters.ModalIsActive('Error')"/>
</template>

<script>
import AddHouseModal from "./AddHouseModal"
import DeleteHouseModal from "./DeleteHouseModal"
import AddFlatModal from "./AddFlatModal"
import AddIntercom from "./AddIntercom"
import UpdateIntercomModal from "./UpdateIntercomModal";
import ErrorModal from "./ErrorModal"
export default {
    components: {
        AddHouseModal,
        DeleteHouseModal,
        AddFlatModal,
        AddIntercom,
        UpdateIntercomModal,
        ErrorModal
    }
}
</script>

<style lang="scss">
    .modal_mask {
        width: 100vw;
        height: 100vh;
        background: rgba(51, 51, 51, 0.2);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
    }
    .modal {
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 11;
        background: #FFFFFF;
        padding: 72px 64px;
        .head {
            font-weight: 700;
            font-size: 30px;
            line-height: 41px;
            margin-bottom: 32px;
        }
        .desc {
            font-size: 16px;
            line-height: 20px;
        }
        .buttons {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 44px;
            button {
                width: 320px;
            }
            .cancel {
                width: 320px;
                height: 64px;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                img {
                    margin-right: 16px;
                }
            }
        }
        .close {
            position: absolute;
            right: 24px;
            top: 24px;
            cursor: pointer;
        }
    }
</style>